import React, { useState, useEffect } from 'react';
import { apiRequest } from '../../services/api';

interface ApiStatus {
  isConnected: boolean;
  lastChecked: Date | null;
  error: string | null;
}

const ApiHealthCheck: React.FC = () => {
  const [apiStatus, setApiStatus] = useState<ApiStatus>({
    isConnected: false,
    lastChecked: null,
    error: null,
  });

  const checkApiHealth = async () => {
    try {
      await apiRequest('GET', '/api');
      setApiStatus({
        isConnected: true,
        lastChecked: new Date(),
        error: null,
      });
    } catch (error: any) {
      setApiStatus({
        isConnected: false,
        lastChecked: new Date(),
        error: error.message || 'Connection failed',
      });
    }
  };

  useEffect(() => {
    checkApiHealth();
    const interval = setInterval(checkApiHealth, 30000); // Check every 30 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center space-x-2">
      <div className={`w-3 h-3 rounded-full ${apiStatus.isConnected ? 'bg-green-500' : 'bg-red-500'}`}></div>
      <span className="text-sm text-white">
        API: {apiStatus.isConnected ? 'Connected' : 'Disconnected'}
      </span>
      {apiStatus.error && (
        <span className="text-xs text-red-500" title={apiStatus.error}>
          ({apiStatus.error.substring(0, 20)}...)
        </span>
      )}
    </div>
  );
};

export default ApiHealthCheck;